export const CountryList = [
    { code :'AU', display : 'Australia'},
    { code :'CA', display : 'Canada'},
    { code :'NZ', display : 'New Zealand'},
    { code :'UK', display : 'United Kingdom'},
    { code :'US', display : 'United States'}
];

export const CodeCountryMap = {
    'AU' : 'Australia',
    'CA' : 'Canada',
    'NZ' : 'New Zealand',
    'UK' : 'United Kingdom',
    'US' : 'United States'
}

export const CountryCodeMap = {
    'Australia' : 'AU',
    'Canada' : 'CA',
    'New Zealand' : 'NZ',
    'United Kingdom' : 'UK',
    'United States' : 'US',
}

export function mapCountryNameToCode(name) {
    return CountryCodeMap[name] || null;
}